// extracted by mini-css-extract-plugin
module.exports = {"message":"ChatBubble_message__3llZK","text":"ChatBubble_text__KUyHk","text_full_screen":"ChatBubble_text_full_screen__hMfOQ"};